var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyPen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60914_50055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7452 1.9375H5.61071C5.19803 1.9375 4.80225 2.10144 4.51044 2.39325C4.21863 2.68506 4.05469 3.08084 4.05469 3.49353V15.9417C4.05469 16.3544 4.21863 16.7502 4.51044 17.042C4.80225 17.3338 5.19803 17.4978 5.61071 17.4978H14.9469C15.3596 17.4978 15.7553 17.3338 16.0471 17.042C16.339 16.7502 16.5029 16.3544 16.5029 15.9417V8.65574",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.948 6.98536C11.0213 6.73433 11.1567 6.50581 11.3417 6.32094L15.2395 2.42154C15.5495 2.11161 15.9698 1.9375 16.4081 1.9375C16.8464 1.9375 17.2668 2.11161 17.5767 2.42154C17.8866 2.73147 18.0607 3.15181 18.0607 3.59012C18.0607 4.02842 17.8866 4.44877 17.5767 4.75869L13.6765 8.65576C13.4916 8.84073 13.2631 8.97613 13.0121 9.04943M10.948 6.98536L10.2968 9.21826C10.2773 9.28521 10.2761 9.35617 10.2934 9.42373C10.3107 9.49128 10.3459 9.55294 10.3952 9.60225C10.4445 9.65156 10.5062 9.68671 10.5737 9.70402C10.6413 9.72133 10.7122 9.72015 10.7792 9.70063L13.0121 9.04943M10.948 6.98536L13.0121 9.04943",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60914_50055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.2222,
    height: 17.2222,
    fill: "white",
    transform: "translate(1.67188 1.10938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyPen);
export default __webpack_public_path__ + "static/media/copy-pen.22fede1287060c2edfe2cc9e00219c5b.svg";
export { ForwardRef as ReactComponent };